module.exports = __webpack_public_path__ + "img/punk7523.f7f58305.png";